import React from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";
import { useFavorites } from "@/hooks/useFavorites";
import { ListingCard } from "@/components/ListingCard";
import { CardSkeletonGrid, EmptyState, ErrorState } from "@/components/common";
import { Heart } from "lucide-react";

export default function Favorites() {
  const navigate = useNavigate();
  const { favoriteIds, toggleFavorite } = useFavorites();
  const { data: listings, isLoading, isError, refetch } = useQuery({ queryKey: ["favorites"], queryFn: () => apiFetch("/favorites") });

  return (
    <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6">
      <h1 className="font-display text-2xl font-extrabold">Saved items</h1>
      <div className="mt-6">
        {isLoading ? (
          <CardSkeletonGrid />
        ) : isError ? (
          <ErrorState onRetry={refetch} />
        ) : listings.length === 0 ? (
          <EmptyState icon={Heart} title="No saved items" message="Tap the heart on any listing to save it here." action={<button onClick={() => navigate("/")} className="mt-2 rounded-full bg-price px-4 py-2 text-sm font-semibold text-white">Browse marketplace</button>} />
        ) : (
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
            {listings.map((l, i) => (
              <ListingCard key={l.id} listing={l} index={i} favorited={favoriteIds.includes(l.id)} onToggleFavorite={toggleFavorite} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
